// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file requests/v1/wizard_step_request.proto (package requests.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file requests/v1/wizard_step_request.proto.
 */
export const file_requests_v1_wizard_step_request: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CiVyZXF1ZXN0cy92MS93aXphcmRfc3RlcF9yZXF1ZXN0LnByb3RvEgtyZXF1ZXN0cy52MSImChFXaXphcmRTdGVwUmVxdWVzdBIRCglzdGVwX25hbWUYASABKAlCfAoPY29tLnJlcXVlc3RzLnYxQhZXaXphcmRTdGVwUmVxdWVzdFByb3RvUAFaBC4vcGKiAgNSWFiqAgtSZXF1ZXN0cy5WMcoCC1JlcXVlc3RzXFYx4gIXUmVxdWVzdHNcVjFcR1BCTWV0YWRhdGHqAgxSZXF1ZXN0czo6VjFiBnByb3RvMw'
    );

/**
 * @generated from message requests.v1.WizardStepRequest
 */
export type WizardStepRequest = Message<'requests.v1.WizardStepRequest'> & {
    /**
     * @generated from field: string step_name = 1;
     */
    stepName: string;
};

/**
 * Describes the message requests.v1.WizardStepRequest.
 * Use `create(WizardStepRequestSchema)` to create a new message.
 */
export const WizardStepRequestSchema: GenMessage<WizardStepRequest> =
    /*@__PURE__*/
    messageDesc(file_requests_v1_wizard_step_request, 0);
